<section class="animated fadeIn">
  <h2 class="product-section-title">NS-Business Card {{ productNumber }}/{{ totalProductCount }}</h2>

  <section *ngIf="product.user as user" class="mb-2">
    <div class="product-container">
      <div class="user-details" [cypress]="'user_details'" privacySensitive>
        <h3 class="user-name-heading">
          {{ user | displayName | async }}
        </h3>
        <div>
          {{ user.birthDate.date | dateFormat: 'D MMMM YYYY' }}
        </div>
        <ng-container *ngIf="user.address as address">
          <div>{{ address.street }} {{ address.houseNumber }} {{ address.addition }}</div>
          <div>{{ address.postcode }} {{ address.city }} {{ user.country.name }}</div>
        </ng-container>
        <div>{{ user.email }}</div>
      </div>

      <div alt="" class="image-container" privacySensitive aria-hidden="true">
        <div class="card-image">
          <div *ngIf="user.image as image" class="user-image">
            <img [src]="image.imageAsBase64 | displayImage" />
          </div>
          <div class="user-name">{{ user | displayName | async }}</div>
          <div *ngIf="company" class="user-company">{{ company.name | truncate: 20 }}</div>
          <div class="user-birthdate">
            <span>{{ 'VERIFY.BIRTH_DATE' | translate }}</span>
            {{ user.birthDate.date | dateFormat: 'DD-MM-YYYY' }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="subscription-title">
    <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
    <span>€ {{ product.price | priceFormat }}</span>
  </div>

  <section class="mb-2">
    <div *ngIf="product.route as route">{{ route.from.naam }} - {{ route.to.naam }}</div>
    <div class="extras-spacing">
      <ng-container *ngIf="product | displayServices | async; else default">
        <nes-text size="sm">{{ 'COMPOSE.CHOOSE_EXTRAS.SERVICES.TITLE' | translate }}: {{ product | displayServices | async }}</nes-text>
      </ng-container>
      <ng-template #default>
        <nes-text> {{'VERIFY.NO_DTD' | translate}}</nes-text>
      </ng-template>
    </div>

    <ng-container *ngFor="let addon of product.addons">
      <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="ic-direct-line">
        <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
        <span>€ {{ addon.price | priceFormat }}</span>
      </div>
    </ng-container>

    <ng-container *ngFor="let addon of product.addons">
      <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="travel-class-line">
        <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
        <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="product.user as user">
      <div class="startdatum-line">
        {{ 'VERIFY.USE_PRODUCT' | translate }}:
        <ng-container *ngIf="user.useProduct.type == ProductStart.DATE && user.useProduct.date as useProductDate; else directly">
          <strong>{{ useProductDate | dateFormat: 'D MMMM YYYY' }}</strong>
        </ng-container>
        <ng-template #directly>
          {{ 'VERIFY.DIRECTLY' | translate }}
        </ng-template>
      </div>
    </ng-container>

    <div *ngIf="!readOnly" class="action-buttons">
      <button class="action-btn" [cypress]="'edit_product'" (click)="edit.emit(product)">
        <nes-icon name="edit" aria-hidden="true"></nes-icon>
        {{ 'VERIFY.BUTTON.EDIT_ORDER' | translate }}
      </button>
      <button class="action-btn" [cypress]="'delete_product'" (click)="delete.emit(product)">
        <nes-icon name="trash" aria-hidden="true"></nes-icon>
        {{ 'BUTTON.DELETE' | translate }}
      </button>
    </div>
  </section>

  <nes-divider *ngIf="productNumber < totalProductCount" class="product-section-divider"></nes-divider>
</section>

